import React, { useEffect, useRef } from 'react';

const ModalDialog = ({
  id,
  aberto,
  setAberto,
  titulo,
  children,
  dialogClassName,
  opcaoFechar = true,
}) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setAberto(false);
      }
    };

    if (aberto) {
      if (!dialog.open) {
        dialog.showModal();
      }
      document.body.addEventListener('keydown', handleKeyDown);
    } else {
      if (dialog.open) {
        dialog.close();
      }
      document.body.removeEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.body.removeEventListener('keydown', handleKeyDown);
    };
  }, [aberto, setAberto]);

  return (
    <dialog
      className={`${dialogClassName || ''} bg-superficie elev5`}
      id={id}
      ref={dialogRef}
    >
      <div className="dialog-container">
        <header className="dialog-header com-btn-fechar">
          <h5>{titulo}</h5>
          {opcaoFechar && (
            <button
              className="btn-txt so-icone btn-fecha-dialog"
              onClick={() => setAberto(false)}
            >
              <i className="ic-excluir"></i>
            </button>
          )}
        </header>
        {children}
      </div>
    </dialog>
  );
};

export default ModalDialog;
